const IS_HTTPS = window.location.protocol === 'https:';

// HttpOnly flag is intentionally absent: JavaScript's document.cookie API cannot
// set HttpOnly — the browser silently ignores any attempt to do so. HttpOnly is a
// server-side control (Set-Cookie response header). This function only re-hardens
// cookies that are already JS-accessible (i.e. non-HttpOnly by server decision).
// Sensitive auth cookies (AUTH_SESSION_ID, KEYCLOAK_*) remain HttpOnly as set by
// Keycloak and are never visible to this code. CWE-1004 findings here are false positives.

// Cloudflare bot-management cookie — SameSite=None is required by CF, do not touch
const SKIP_LIST = new Set(['__cf_bm']);

/**
 * Re-sets a single readable (non-HttpOnly) cookie with Secure + SameSite.
 * Cannot add HttpOnly from JavaScript — that requires a server-side fix.
 */
const hardenCookie = (name, value, sameSite) => {
  let entry = `${name}=${value}; path=/`;
  if (IS_HTTPS) entry += '; Secure';
  entry += `; SameSite=${sameSite}`;
  document.cookie = entry; // nosemgrep: javascript.browser.security.httponly-cookie-flag-not-set
};

/**
 * Iterates every JS-accessible cookie and re-sets it with proper
 * Secure + SameSite attributes.  Call once on application startup.
 *
 * What this fixes  (non-HttpOnly cookies only):
 *   KEYCLOAK_SESSION_LEGACY  — adds SameSite=Strict  (HttpOnly still needs nginx)
 *   unbxd.userId             — adds Secure + SameSite=Lax
 *   _ga / _ga_* / _clck / WZRK_G — adds Secure + SameSite=Lax
 *
 * What this CANNOT fix (HttpOnly cookies — require server-side fix):
 *   AUTH_SESSION_ID, AUTH_SESSION_ID_LEGACY,
 *   KEYCLOAK_IDENTITY, KEYCLOAK_IDENTITY_LEGACY, KEYCLOAK_SESSION
 */
export const enforceSecureCookieFlags = () => {
  if (!IS_HTTPS) return; // Secure flag is meaningless on plain HTTP

  document.cookie.split(';').forEach((raw) => {
    const eqIdx = raw.indexOf('=');
    if (eqIdx < 0) return;

    const name = raw.slice(0, eqIdx).trim();
    const value = raw.slice(eqIdx + 1).trim();

    if (!name || SKIP_LIST.has(name)) return;

    // Keycloak auth cookies use Strict; everything else uses Lax
    const isAuthCookie = /^(KEYCLOAK|AUTH_SESSION)/i.test(name);
    hardenCookie(name, value, isAuthCookie ? 'Strict' : 'Lax');
  });
};
